// extracted by mini-css-extract-plugin
export default {"dot":"user-status_dot__7Q37F"};